import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';

import logoCircular from 'src/assets/images/logo-circular.png';

import styles from './AboutLogo.module.scss';

const AboutLogo = () => (
	<AnimationOnScroll animateIn="animate__zoomIn" animateOnce={true} offset={0} delay={1500}>
		<AnimationOnScroll animateIn="animate__pulse" delay={2000} initiallyVisible={true} className={styles.aboutImg}>
			<img src={logoCircular} alt="Logo Circular Cymet Solutions" />
		</AnimationOnScroll>
	</AnimationOnScroll>
);

export default AboutLogo;
